import _ from "lodash";

// Column types whose values come from an options list, so the stored value can be a
// different type than the column itself. Those are the columns valueDataType is for.
const OPTION_BACKED_TYPES = ["array", "enum"];
const NON_STRING_VALUE_TYPES = ["boolean", "number"];

const PlatformSdk = require("@gluenetworks/platform-sdk-remote");

const TriggerTypeEntity = PlatformSdk.entities.ws.TriggerType;
const DeviceEntity = PlatformSdk.entities.ws.Device;
const ConfigAuditPolicyEntity = PlatformSdk.entities.ws.ConfigAuditPolicy;
const OsImageEntity = PlatformSdk.entities.ws.OsImage;
const OsImageServerEntity = PlatformSdk.entities.ws.OsImageServer;
const OsUpgradePlanEntity = PlatformSdk.entities.ws.OsUpgradePlan;

export const getFilterProperties = (type) => {
    switch (type) {
        case "AUDIT_POLICIES":
            return ConfigAuditPolicyEntity.$filterProperties;
        case "FILE_SERVERS":
            return OsImageServerEntity.$filterProperties;
        case "FILES":
            return OsImageEntity.$filterProperties;
        case "OS_PLANS":
            return OsUpgradePlanEntity.$filterProperties;
        case "SCHEDULES":
            return TriggerTypeEntity.$filterProperties;
        case "DEVICES":
            return DeviceEntity.$filterProperties;
        default:
            break;
    }

    return false;
};

export const getColumnsData = (filterData = [], columnConfigData = []) => {
    let userColumns = [];
    userColumns = Object.keys(columnConfigData).map((column) => {
        const columnDefinition = {
            name: columnConfigData[column].hasOwnProperty("path")
                ? columnConfigData[column].path
                : column,
            label: columnConfigData[column].label,
        };
        const OptionsObject = [];
        if (columnConfigData[column].hasOwnProperty("options")) {
            if (_.isArray(columnConfigData[column].options)) {
                columnConfigData[column].options.forEach((item) => {
                    OptionsObject.push({value: item.value, label: item.title});
                });
            } else {
                Object.keys(columnConfigData[column].options).forEach((item) => {
                    return OptionsObject.push({
                        value: item,
                        label: columnConfigData[column].options[item].hasOwnProperty("title")
                            ? columnConfigData[column].options[item].title
                            : columnConfigData[column].options[item],
                    });
                });
            }
            Object.assign(columnDefinition, {options: OptionsObject});
        }
        if (columnConfigData[column].hasOwnProperty("dataType")) {
            Object.assign(columnDefinition, {dataType: columnConfigData[column].dataType});
        }

        if (columnConfigData[column].hasOwnProperty("filterLabel")) {
            Object.assign(columnDefinition, {filterLabel: columnConfigData[column].filterLabel});
        }

        if (columnConfigData[column].hasOwnProperty("typeInfo")) {
            Object.assign(columnDefinition, {typeInfo: columnConfigData[column].typeInfo});
        }

        return columnDefinition;
    });

    let filterProps = [];
    filterProps = filterData;

    const entityProps = filterProps.reduce(
        (propsObj, prop) => Object.assign(propsObj, {[prop.name]: prop}),
        {}
    );

    // What the entity schema says this column stores. Null for a sub-field the parent
    // schema does not describe, which drops the column below, as it always has.
    const getSchemaType = (fieldName, subFieldName) => {
        if (subFieldName && _.has(entityProps, [fieldName, "schema"])) {
            return _.get(entityProps, [fieldName, "schema", subFieldName, "dataType"], null);
        }
        return _.get(entityProps, [fieldName, "dataType"]);
    };

    return userColumns.reduce((columnsData, columnConfig) => {
        const [fieldName, subFieldName] = columnConfig.name.split(".");
        // The type the column config declares, lower-cased, e.g. "enum" for a select.
        // The && keeps a missing type falsy so the column still drops out below.
        const columnConfigType =
            columnConfig.dataType && String(columnConfig.dataType).toLowerCase();
        const schemaType = getSchemaType(fieldName, subFieldName);
        const valueType = schemaType === undefined ? columnConfigType : schemaType;

        if (!valueType) {
            return columnsData;
        }

        const normalizedValueType = String(valueType).toLowerCase();
        _.defaults(columnConfig, {dataType: normalizedValueType});

        // The type of the values behind an options list, recorded only when it differs from
        // the column type itself. A plain string enum needs nothing here.
        if (
            OPTION_BACKED_TYPES.includes(columnConfigType) &&
            NON_STRING_VALUE_TYPES.includes(normalizedValueType)
        ) {
            columnConfig.valueDataType = normalizedValueType;
        }

        return columnsData.concat(columnConfig);
    }, []);
};
